import { useState, type FormEvent } from "react";
import { Navigate, useNavigate } from "react-router";
import { useAuth } from "../auth/AuthContext.js";
import { errorMessage } from "../lib/errors.js";
import { HeartIcon } from "../components/icons.js";

/** 登录页。初始化还没做的话，先去 setup（那是唯一能创建账号的地方）。 */
export function LoginPage() {
  const { user, initialized, loading, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (!loading && initialized === false) return <Navigate to="/setup" replace />;
  if (user !== null) return <Navigate to="/" replace />;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(username.trim(), password);
      navigate("/", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth">
      <form className="auth-card" onSubmit={onSubmit}>
        <div className="auth-brand">
          <span className="brand-mark">
            <HeartIcon size={18} style={{ color: "#fff" }} />
          </span>
          <span>我们日记</span>
        </div>
        <div>
          <h1 className="auth-title">欢迎回来</h1>
          <p className="auth-sub" style={{ marginTop: 6 }}>
            这是一个只有你们两个人的私密日记本。
          </p>
        </div>

        {error !== null && <div className="banner banner-error">{error}</div>}

        <label className="field-block">
          <span className="field-label">昵称</span>
          <span className="field">
            <input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="你的昵称"
              autoComplete="username"
              autoFocus
            />
          </span>
        </label>

        <label className="field-block">
          <span className="field-label">密码</span>
          <span className="field">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="至少 8 位"
              autoComplete="current-password"
            />
          </span>
        </label>

        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={busy || username.trim() === "" || password === ""}
        >
          {busy ? "登录中…" : "登录"}
        </button>
        <p className="small ghost-text" style={{ textAlign: "center" }}>
          忘记了密码？在服务器上跑 `pnpm ops reset-password` 重置。
        </p>
      </form>
    </div>
  );
}
